import { Component, ChangeDetectionStrategy, Input, inject, DOCUMENT } from '@angular/core';
import { MenuItem } from '@shared/models/menu-item.model';

import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgClass } from '@angular/common';
import { LocalizePipe } from '../../i18n/pipes/lozalize.pipe';

@Component({
    selector: 'app-menu-desktop',
    templateUrl: './menu-desktop.component.html',
    styleUrls: ['./menu-desktop.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, NgClass, RouterLinkActive, TranslatePipe, LocalizePipe],
})
export class MenuDesktopComponent {
    private document = inject(DOCUMENT);
    private translateService = inject(TranslateService);

    @Input({ required: true }) menuItems!: MenuItem[];
    @Input({ required: true }) isMainPage!: boolean;

    goToPartnerPlatform(): void {
        const partnerPlatformSubdomain = 'app';
        const partnerPlatformUrl = `${this.document.location.protocol}//${partnerPlatformSubdomain}.${this.document.location.host}`;

        this.document.location.href = partnerPlatformUrl;
    }

    get currentLang() {
        return this.translateService.currentLang;
    }
}
